import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Carrier, CarrierTypes } from '@app/services/carriers/carrier.model';
import { CreateCarrierComponent } from '../create-carrier.component/create-carrier.component';
import { EditCarrierComponent } from '../edit-carrier.component/edit-carrier.component';
import { takeUntil } from 'rxjs/operators';
import { Actions, ofType } from '@ngrx/effects';
import { CarriersActions } from '../../store/actions';
import { ErrorResponseDialog } from '../error-response.dialog/error-response.dialog';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatDrawer } from '@angular/material/sidenav';
import { getCarrierDisplayName } from '../../configs';
import { isCarrierSupportsExternalAuth } from '@app/pages/checkout-app/utils/carrier.utils';

const enum DROP_DOWN_ACTIONS {
  EDIT_CARRIER = 'editCarrier',
  DELETE_CARRIER = 'deleteCarrier',
  DUPLICATE_CARRIER = 'duplicateCarrier',
}

export enum CARRIER_ERRORS_RESPONSE {
  DEFAULT = "This delivery service couldn't be added, please check your details and retry.",
  TOKEN_WEBHOOKS_VERIFY = 'Hmm... It seems like that Customer Key isn’t valid. \n Please enter it correctly to add this delivery service.',
}

@Component({
  selector: 'app-side-drawer',
  templateUrl: './side-drawer.component.html',
  styleUrls: ['./side-drawer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SideDrawerComponent implements OnInit {
  STATE = {
    CHOOSE_CARRIER: 'chooseCarrier',
    CREATE_CARRIER: 'createCarrier',
    EDIT_CARRIER: 'editCarrier',
    DUPLICATE_CARRIER: 'duplicateCarrier',
  };

  @ViewChild(EditCarrierComponent) editCarrier: EditCarrierComponent;
  @ViewChild(CreateCarrierComponent) createCarrier: CreateCarrierComponent;
  @Input() currentCarrier: Carrier;
  @Input() shopId: number;
  @Input() drawer: MatDrawer;
  @Input() buttonActionText: string = 'Add';
  @Input() isCreatingCarrier: boolean = false;

  ngUnsubscribe$ = new Subject<any>();
  chosenCarrierType: CarrierTypes;
  isPerformExternalAuth = false;
  isChosenCarrierSupportsExternalAuth = false;
  state: string;

  constructor(
    private readonly actions$: Actions,
    private dialog: MatDialog,
  ) {
    this.detectCreateOrEditCarrierFailure();
  }

  ngOnInit() {
    this.state = this.STATE.CHOOSE_CARRIER;
    this.drawer.closedStart.subscribe(() => {
      this.onClose();
    });
  }

  detectCreateOrEditCarrierFailure(): void {
    this.actions$
      .pipe(
        takeUntil(this.ngUnsubscribe$),
        ofType(CarriersActions.editCarrierFailure, CarriersActions.addNewCarrierFailure),
      )
      .subscribe((res) => {
        this.isCreatingCarrier = false;
        let responseMessage = res?.errorMessage || CARRIER_ERRORS_RESPONSE.DEFAULT;
        if (res?.errorMessage?.toLowerCase().includes('token')) {
          responseMessage = CARRIER_ERRORS_RESPONSE.TOKEN_WEBHOOKS_VERIFY;
        }
        // TODO: MUST!!! to refactor this code after release
        if (res?.errorMessage?.includes('Your registration unfortunately failed due to the following UPS error')) {
          responseMessage = res.errorMessage as any;
        }
        this.dialog.open(ErrorResponseDialog, {
          panelClass: 'carrier-action-error',
          data: {
            title: 'Unable to add delivery service',
            message: responseMessage,
          },
        });
      });
  }

  onOpenCarrier(event: any): void {
    this.chosenCarrierType = event;
    this.state = this.STATE.CREATE_CARRIER;
    this.isChosenCarrierSupportsExternalAuth = isCarrierSupportsExternalAuth(this.currentCarrier);
  }

  onClose(): void {
    this.chosenCarrierType = null;
    this.currentCarrier = null;
    this.drawer.close();
    this.state = undefined;
  }

  initAddNewCarrier(): void {
    this.isCreatingCarrier = false;
    this.state = undefined;
    this.buttonActionText = 'Add';
    this.state = this.STATE.CHOOSE_CARRIER;
  }

  onBackToList(): void {
    this.state = this.STATE.CHOOSE_CARRIER;
  }

  closeAfterAction(): void {
    this.onClose();
  }

  isPending(event: boolean): void {
    this.isCreatingCarrier = event;
  }

  onDropDownAction(action: string, carrier: Carrier) {
    this.currentCarrier = carrier;
    console.log(`state: ${action}`);
    this.isCreatingCarrier = false;
    switch (action) {
      case DROP_DOWN_ACTIONS.EDIT_CARRIER: {
        this.buttonActionText = 'Save';
        this.drawer.toggle();
        this.state = action;
        this.isChosenCarrierSupportsExternalAuth = isCarrierSupportsExternalAuth(this.currentCarrier);
        break;
      }
      case DROP_DOWN_ACTIONS.DUPLICATE_CARRIER: {
        this.buttonActionText = 'Save as new';
        this.drawer.toggle();
        this.state = action;
        break;
      }
    }
  }

  onSubmit() {
    console.log(`on submit state: ${this.state}`);
    if (this.state == DROP_DOWN_ACTIONS.EDIT_CARRIER || this.state == DROP_DOWN_ACTIONS.DUPLICATE_CARRIER) {
      this.editCarrier.onSubmit({ reauthenticate: this.isPerformExternalAuth });
    } else {
      this.createCarrier.onSubmit();
    }
  }

  getActionString(): string {
    switch (this.state) {
      case this.STATE.EDIT_CARRIER: {
        return `Edit ${getCarrierDisplayName(this.currentCarrier?.type?.name)} account`;
      }
      default: {
        return `Add ${
          this.chosenCarrierType?.name
            ? `${getCarrierDisplayName(this.chosenCarrierType?.name)} account`
            : 'delivery service'
        } `;
      }
    }
  }

  onSetReauthenticateMode(val: boolean) {
    this.isPerformExternalAuth = val;
  }
}
